import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=32538f91&scoped=true&"
var script = {}
import style0 from "./Heart.vue?vue&type=style&index=0&id=32538f91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32538f91",
  null
  
)

export default component.exports